export const range = function(length: number) {
  return [...Array(length).keys()];
};